<template>
  <div class="main-content" id="panel">
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-2 col-4">
              <h2>OFFERINGS</h2>
            </div>
            <div class="col-lg-10 col-4">
              <div class="input-group d-inline-flex justify-content-end">
                <div class="recap mr-2 mt-1" >
                  <!-- <span style="color: #000;">COUNT : </span> -->
                  <span class="text-success" style="bottom: 1px;">
                    BACKEND DATA LAST REFRESHED : 
                  </span>
                  <span class="text-warning" style="bottom: 1px;">
                   {{ offeringFeedStatus.lastRefreshed ? moment.utc(offeringFeedStatus.lastRefreshed).local().format('hh:mm:ss A') : "" }}
                  </span>
                  <!-- <span style="bottom: 0px;" v-if="offeringFeedStatus.viewStatus == 'REFRESHING' ">
                    <span   class="fas fa-sync-alt fa-spin  cursor-pointer"
                    v-bind:class="{ 'fa-spin': countLoading }"  aria-hidden="true"></span>
                  </span> -->
                 
                </div>
                <span style="font-size: 14px;" v-if="this.offerSelected && this.offerSelected.length"
                  class="text-uppercase text-white mr-2 mt-2 font-weight-bold">{{ this.offerSelected.length }} Selected <i
                    @click="clearSelection()" class="cursor-pointer text-warning fa fa-trash"></i></span>
                <button  type="button" @click="sendEmailToCustomer()" class="btn btn-success btn-sm rounded mr-2">
                  <span> <i class="fas fa-envelope"></i> SEND EMAIL</span>
                </button>
                <button :disabled="!offerings.length" type="button" @click="openExportModal()" class="btn btn-warning btn-sm rounded mr-2">
                  <span v-if="!isExport"> <i class="fas fa-download"></i> EXPORT</span>
                  <span v-if="isExport"><i class="fa fa-spinner fa-spin"></i> EXPORTING..</span>
                </button>
                <div class="recap mr-2 mt-1">
                  <!-- <span style="color: #000;">COUNT : </span> -->
                  <span class="text-success">
                    FILTERS : {{ offeringFeedCount.totalActiveFilters }}
                  </span>
                  <span class="text-warning">
                    OFFERS : {{ offeringFeedCount.totalHits }}
                  </span>
                  <span @click="getFeedRecap()" class="fas fa-sync-alt  cursor-pointer"
                    v-bind:class="{ 'fa-spin': countLoading }" data-toggle="tooltip" data-placement="left"
                    title="Refresh count" aria-hidden="true"></span>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
    <div class="container-fluid mt--6 filter-show">
      <div class="card w-100 p-2 mb-2  d-inline-block">
        <div class="d-flex justify-content-between">
          <h5 class="ml-3">Filters</h5>
          <div class="hint-color" style="margin-left: auto; margin-right: 5px;">
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="Offer not valid">
                <i class="fa fa-info-circle" style="color: rgb(255 147 147);"></i>
              </span>
            </div>
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="There are multiple offers available for the CUSIP">
                <i class="fa fa-info-circle" style="color: #ffa500;"></i>
              </span>
            </div>
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="Material Events">
                <i class="fa fa-info-circle" style="color: #90ee9094"></i>
              </span>
            </div>
            <div>
              <span class="hint" data-toggle="tooltip" data-placement="left"  title="Hidden Item">
                <i class="fa fa-info-circle" style="color: rgb(151 151 151);"></i>
              </span>
            </div>
          </div>
          <span class="btn btn-link" @click="showFilters = !showFilters">
            <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"></i> {{ showFilters ? 'Hide' :
              'Show' }} Filters
          </span>
        </div>
        <div class="row" v-if="showFilters">
          <div class="col-lg-12">
            <form class="row">
              <div class="col-md-6 col-lg-3">
                <label>CUSIP</label>
                <input type="text" class="form-control" v-model.trim="searchValue" style="height: 40px;" />
              </div>
              <div class="col-md-6 col-lg-3">
                <label>ECN</label>
                <multiselect v-model="seletedEcn" placeholder="Select Ecn" :options=ecnList :multiple="false"
                  :limit="3"></multiselect>
              </div>
              <div class="col-md-6 col-lg-3 text-center mt-2">
                <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-3">Clear</button>
                <button @click="getOfferList()" type="button"
                  class="btn btn-primary rounded mt-3">Filter</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
              <div class="mb-2 col-md-6 d-flex" style="float: right;">
                <span v-if="isPreviewMode" style="
                          padding: 14px;
                          font-weight: 600;
                          color: #ff9e47;
                      ">You are previewing : {{previewFilterPayload ? previewFilterPayload.filter.name : ''}}</span>
                <h5 class="cursor-pointer mt-3 mr-3" @click="selectColumnOption()">
                  <i class="fa fa-cog"></i>
                  Column Options
                </h5>
                <select @change="filterChange()" class="form-control cursor-pointer" id="exampleFormControlSelect1"
                  v-model="seletedFilter">
                  <option value>Please select</option>
                  <option v-for="filter in matchedFilterList" :key="filter.id" v-bind:value="filter.filterName">
                    {{ filter.filterName }}</option>
                </select>
                <div class="dropdown mt-2">
                  <button class="btn btn-success btn-sm rounded dropdown-toggle ml-2 mt-0" type="button"
                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <div>
                      <i aria-hidden="true" class="fa fa-filter"></i> SAVED FILTERS
                    </div>
                  </button>

                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton" style="max-height: 300px; overflow-y: scroll;">
                    <a v-for="filter in matchedFilterList" v-bind:key="filter.id" class="dropdown-item">
                      <div class="d-flex justify-content-between">
                        <span class="cursor-pointer" @click="filterBySavedFilter(filter.filterName)">{{ filter.filterName
                          | truncate(20, '...')}} </span>
                        <span>
                          <i class="cursor-pointer fas fa-pencil-alt" @click="editFlter(filter.filterName)"></i>
                        </span>
                      </div>
                    </a>

                    <!-- <a class="dropdown-item cursor-pointer" @click="openImportInventoryModal()">HOLDINGS</a>
                    <a class="dropdown-item cursor-pointer" @click="openInvAccHoldingModal()">INVENTORY ACCOUNT HOLDINGS</a> -->
                  </div>
                </div>
              </div>
              <table  class="table align-items-center table-flush bidtbl imstbl" style="min-height: 350px;">
                <thead class="thead-light psticky" v-if="columnHeaders.length">
                  <tr>
                    <th class="text-center">
                      <input v-model="isSelectAll" @change="selectAll()" type="checkbox"
                        class="cursor-pointer form-check-input" v-if="offerings.length > 0" />
                      </th>
                    <th 
                      class="text-center sort" > Ims Offer </th>
                    <th 
                      class="text-center sort" 
                      v-for="(column, index) in columnHeaders" :key="index"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == column.columnvalue  ? 'sort-asc' : '',
                        sortOrder == 'DESC' && sortColumn == column.columnvalue  ? 'sort-desc' : '',
                        ]"  
                      @click="sort(column.columnvalue)"
                    >
                    {{ column.column === 'SP_RATING' ? 'S&P RATING' : column.column.replace(/_/g, ' ') }}</th>
                    <th class="text-center">Action</th>                      
                  </tr>
                </thead>
                <tbody class="list" >
                  <tr v-if="offerings.length == 0 && !loading">
                    <td>
                      <p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="offer in offerings" :key="offer.id" v-bind:class="{ 'row-highlight-red': !offer.isValid ,'row-highlight-green': offer.highlightMaterialEvent ,'row-highlight-grey': offer.isHidden }">
                    <td class="text-center">
                      <input v-if="!offer.isFeedOfferNull" v-model="offer.isSelect" @change="selectSingleItem(offer)" type="checkbox"
                        class="cursor-pointer form-check-input" />
                    </td>
                    <td class="text-center">
                      <div class="d-flex" v-if="offer.imsOfferPrice">
                        <div class="m-2">
                          <input style="margin-top: 3px;" v-model="offer.isIMSofferSelect"  @change="selectIMSOfferItem(offer)" type="checkbox"
                          class="cursor-pointer form-check-input" />
                        </div>
                        <div class="text-left">
                          <div class="text-info"> Cost  : {{ offer.imsOfferCost  }} |  Price : {{ offer.imsOfferPrice | currency  }} </div>
                          <!-- <div>Qty : {{ offer.imsOfferQty  }} </div> -->
                          <div  class="text-error">Qty : {{ offer.imsOfferQty  }} | Min Qty : {{ offer.imsOfferMinQty  }}  </div>
                          
                        </div>
                      </div>
                      <div class="text-center" v-if="!offer.imsOfferPrice">
                        <span>N/A</span>
                      </div>
                        
                    </td>
                    <td class="text-center" v-for="(column, index) in columnHeaders" :key="index">
                      <span v-if="column.columntype == 'currency'">{{ offer[column.columnvalue] | currency }}</span>
                      <span v-else-if="column.columntype == 'percentage'">
                        <div v-if="column.columnvalue == 'askYtc' || column.columnvalue == 'askYtm' || column.columnvalue == 'askYtw'">
                          <span v-if="typeof offer[column.columnvalue] === 'number'">
                            <span v-if="offer[column.columnvalue] * 100 > 16">
                              <span>N/A</span>
                            </span>
                            <span v-else>
                              {{offer[column.columnvalue] | percent(3)}}
                            </span>
                          </span>
                          <span v-else>{{offer[column.columnvalue]}}</span>
                        </div>
                        <div v-else>
                          <span v-if="typeof offer[column.columnvalue] === 'number'">{{offer[column.columnvalue] | percent(3)}}</span>
                          <span v-else>{{offer[column.columnvalue]}}</span>
                        </div>

                      </span>
                      <span v-else-if="column.columnvalue == 'cusip'">
                        <span v-if="offer.offerCount > 1">
                          <span class="cusips cusip-orange">{{offer[column.columnvalue]}}</span> 
                        </span>
                        <span v-if="offer.offerCount <= 1">
                          {{offer[column.columnvalue]}}
                        </span>
                      </span>
                       <span v-else-if="column.columnvalue == 'settlementDate'">
                        <span v-if="offer.settlementDate && !offer.isRegularSettlement" class="text-red">{{offer[column.columnvalue]}}</span>
                        <span v-else>{{offer[column.columnvalue]}}</span>
                      </span>
                       <span v-else-if="column.columnvalue == 'firstSettlementDate'">
                          <span v-if="!offer.settlementDate && !offer.isRegularSettlement " class="text-red">{{offer[column.columnvalue]}}</span>
                          <span v-else>{{offer[column.columnvalue]}}</span>
                      </span>
                      <span v-else-if="Array.isArray(offer[column.columnvalue])">{{offer[column.columnvalue].toString()}}</span>
                      <span v-else-if="column.columnvalue == 'minQty'">{{ offer[column.columnvalue] ? offer[column.columnvalue]  : 'N/A'}}</span>

                      <span v-else>{{ offer[column.columnvalue] }}</span>
                    </td>
                    <td class="text-center">
                      <div class="dropdown">
                          <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fas fa-ellipsis-v"></i>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <button 
                              v-on:click.stop.prevent="" 
                              @click="preConfirmOfferHide(offer)"
                              class="dropdown-item" type="button">
                              {{ offer.isHidden ? 'SHOW' : 'HIDE' }}
                            </button>
                            <button 
                              
                              @click="showCusipOfferModal(offer)"
                              class="dropdown-item" type="button">
                                OFFERS
                            </button>
                            <button v-if="offer.highlightMaterialEvent"
                                class="dropdown-item" type="button" @click="showMaterialEventModal(offer)">
                                MATERIAL EVENTS
                              </button>
                              <!-- <button  @click="restartEcn(ecn.ecnId)" class="dropdown-item" type="button">Restart</button>
                              <button :disabled="!settings.isSendToEcn"  @click="suspendEcn(ecn.ecnId)"  class="dropdown-item" type="button">Suspend</button>
                              <button :disabled="!settings.isSendToEcn"  @click="reupload(ecn.ecnId)"  class="dropdown-item" type="button">Reupload</button> -->
                          </div>
                      </div>
                      <!-- <button v-if="!offer.isHidden" v-on:click.stop.prevent="" @click="hideRow(offer)"
                        class="btn btn-warning rounded ml-2 mt-0 mb-2" type="button">
                        <i :class="['fa', offer.isHidden ? 'fa-eye' : 'fa-eye-slash']"
                          aria-hidden="true"></i>{{ offer.isHidden ? 'SHOW' : 'HIDE' }}
                      </button>
                      <button v-if="offer.offerCount > 1" @click="showCusipOfferModal(offer)"
                        class="btn btn-info rounded ml-2 mt-0 mb-2" type="button">
                        <i class="fas fa-dollar-sign"
                          aria-hidden="true"></i>OFFERS
                      </button>
                      <button v-if="offer.highlightMaterialEvent"
                        class="btn btn-primary rounded ml-2 mt-0 mb-2" type="button" @click="showMaterialEventModal(offer)">
                        <i class="fas fa-bell"
                          aria-hidden="true"></i>MATERIAL EVENTS
                      </button> -->
                    </td>
                  </tr>
                </tbody>
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt="" /></div>

              </table>
              <nav aria-label="Page navigation example" v-if="!(offerings.length == 0)">
                <ul class="pagination justify-content-center">
                  <li class="page-item" v-bind:class="{ disabled: !prevCursor }">
                    <a class="page-link cursor-pointer" @click="nextOrPrev('prev')">
                      <i class="fa fa-angle-left"></i>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item active"><a class="page-link">{{ currentPage }}</a></li>
                  <li class="page-item" v-bind:class="{ disabled: !nextCursor }">
                    <a class="page-link cursor-pointer" @click="nextOrPrev('next')">
                      <i class="fa fa-angle-right"></i>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SendEmail v-if="sendToCustomerModalOpen" v-bind:selectedFilter="seletedFilter" v-bind:offers="this.allPageofferings" v-bind:offerIds="this.offerSelected" @close="toggleSendToCustomerModal()">
    </SendEmail>
    <AddFilter @previewFilter="showPreview" v-if="showAddFilterModal" v-bind:selectedfilter="filterDataForEdit" @close="toggleEditFilterModal" />
    <FeedColumnOption v-if="showColumnOption" @close="selectColumnOption()"/>
    <CusipOffer v-if="showCusipOffer" v-bind:offer="selectedOffer" @close="showCusipOfferModal()" />
    <MaterialEvents v-if="showMaterialEvent" v-bind:offer="selectedOffer" @close="showMaterialEventModal()" />
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import Swal from 'sweetalert2';
import SendEmail from "./SendToCustomerModal"
import AddFilter from "./FeedAddFilter.vue"
import FeedColumnOption from "./feedColumnOptions.vue"
import CusipOffer from "./CusipOffersListModal.vue"
import MaterialEvents from "./MaterialEventsListModal.vue"
export default {
  name: "imsAllOfferListComponent",
  components: {
    SendEmail,
    AddFilter,
    FeedColumnOption,
    CusipOffer,
    MaterialEvents
  },
  data() {
    return {
      accessToken: null,
      config: config,
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchValue: "",
      totalRows: 0,
      selectedCusip: "",
      sortColumn: null,
      sortOrder: null,
      stateConstants: stateConstants,
      offerings: [],
      allPageofferings: [],
      cursor: "",
      nextCursor: null,
      prevCursor: null,
      seletedEcn: "",
      ecnList: ["IBP", "TMC", "MKTX" ,"TWD"],
      showFilters: false,
      offeringFeedCount: {},
      countLoading: false,
      matchedFilterList: [],
      seletedFilter: "",
      isExport: false,
      sendToCustomerModalOpen: false,
      isSelectAll: false,
      offerSelected: [],
      showAddFilterModal: false,
      filterDataForEdit: "",
      columnHeaders: [],
      showColumnOption: false,
      showCusipOffer : false,
      selectedOffer : null,
      offeringFeedStatus : {},
      totalSelectedOffers : 0,
      showMaterialEvent : false,
      isListAPIProcessing : false,
      isPreviewMode : false,
      previewFilterPayload  : null

    };
  },
  methods: {
    filterChange() {
      this.isPreviewMode = false;
      this.getOfferList();
    },
    showPreview(filter) {
      this.showAddFilterModal = false;
      this.isPreviewMode = true;
      this.previewFilterPayload = filter;
      console.log("preview filter payload", this.previewFilterPayload)
      this.getOfferList();

      // this.offerings = offersForPreview;
      
    },
    getTotalSelectedOffersCount(){
      var count = 0;
      this.offerings.forEach(function (offer) {
        if (offer.isSelect || offer.isIMSofferSelect) {
          count++ 
        }
      });
      this.totalSelectedOffers = count

    },
    showCusipOfferModal(offer){
      this.selectedOffer = offer
      this.showCusipOffer = !this.showCusipOffer;
    },
    showMaterialEventModal(offer){
      this.selectedOffer = offer
      this.showMaterialEvent = !this.showMaterialEvent;
    },
    selectColumnOption() {
      this.showColumnOption = !this.showColumnOption;
      if (!this.showColumnOption)
        this.getSavedColumnOptions()
    },
    editFlter(name) {
      this.loading = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/offering-feed/filter?id=" + this.getFilterIdByName(name),
          auth
        )
        .then((res) => {
          this.filterDataForEdit = res.data;
          this.loading = false;
          this.showAddFilterModal = !this.showAddFilterModal;
        })
    },
    toggleEditFilterModal(param) {
      this.showAddFilterModal = !this.showAddFilterModal;
      this.getMatchedFilter(param);
    },
    filterBySavedFilter(filterName) {
      this.seletedFilter = filterName;
      this.getOfferList();
    },
    getFilterIdByName(filterName) {
      const item = this.matchedFilterList.find(entry => entry.filterName === filterName);
      return item ? item.id : "";
    },
    getFilterNameById(filterId) {
      const item = this.matchedFilterList.find(entry => entry.id === filterId);
      return item ? item.filterName : "";
    },
    clearSelection() {
      this.offerSelected = [];
      this.isSelectAll = false;
      this.offerings.forEach(function (offer) {
        offer.isSelect = false,
        offer.isIMSofferSelect = false
      })
    },
    selectAll() {
      var self = this;
      this.allPageofferings.forEach(function (data) {
        data.isSelect = self.isSelectAll;
      });

      // this.offerSelected = [];
      this.offerings.forEach(function (offer) {
      if(!offer.isIMSofferSelect){
        offer.isSelect = self.isSelectAll;

      }
        if (self.isSelectAll) {
          // Check if the offer.id is already in offerSelected, only push if it's not
          if (!self.offerSelected.includes(offer.id)) {
            self.offerSelected.push(offer.id);
          }
        }
        else {
          // Remove the item if it's being deselected
          const index = self.offerSelected.indexOf(offer.id);
          if (index !== -1) {
            self.offerSelected.splice(index, 1); // Remove the item from the array
          }
        }
      });
    },
    async preConfirmOfferHide(offer){
        let checkboxHTML = "" // Loop through offer.filters and create checkboxes
            for (const [key, value] of Object.entries(offer.filters)) {
              checkboxHTML += `
                <div class="form-check" style="display: block; margin-bottom: 8px;">
                  <input id="swal-filter-${key}" type="checkbox" checked class="form-check-input" value="${key}">
                  <label style="font-size: 16px; margin-left: 6px;" class="form-check-label" for="swal-filter-${key}">${value}</label>
                </div>
              `;
            }
        const { value } = await Swal.fire({
              title: `${offer.isHidden ? 'Show' : 'Hide'} this offer for following filters?`,
              html: `
                <form>
                  <div class="form-row justify-content-center mt-4" style=" flex-direction: column; align-items: start; margin-left: 145px;">
                    ${checkboxHTML}
                  </div>  
                </form>
              `,
              showCancelButton: true,
              confirmButtonText: `${offer.isHidden ? 'Show' : 'Hide'} `,
              focusConfirm: false,
              preConfirm: () => {
                //get checked values
                const checkedFilters = [];
                for (const [key] of Object.entries(offer.filters)) {
                  if (document.getElementById(`swal-filter-${key}`).checked) {
                    checkedFilters.push(Number(key));
                  }
                }
                if(checkedFilters.length == 0){
                    Swal.showValidationMessage("Please select at least one filter");
                    return false;
                }
                return {checkedFilters };

              },
            });

            if (value) {
              this.hideRow(offer,value.checkedFilters)
            }

    },
    hideRow(offerData, checkedFilters) {
        const auth = {
          headers: { "org-token": authService.getOrgToken() },
        };
        this.loading = true;
        let data = {
          "userId": authService.getUser().id,
          "cusip": offerData.cusip,
          "price": offerData.askPx,
          "filterIds" : checkedFilters,
        }
        if(offerData.isHidden){
          delete data.price
        }

        let url = offerData.isHidden ? "/offering-feed/unhide" : "/offering-feed/hide"

        this.$http
          .post(
            config.baseUrlAutoBidder +
            url, data,
            auth
          )
          .then(() => {
            this.getOfferList("refresh")
          })
          .catch((e) => {
            console.log(e);
          });
      
    },
    toggleSendToCustomerModal() {
      this.sendToCustomerModalOpen = !this.sendToCustomerModalOpen;
    },
    selectIMSOfferItem(selectedItem){
      this.allPageofferings.forEach(function (data) {
        if (data.id == selectedItem.id) {
          data.isIMSofferSelect = selectedItem.isIMSofferSelect
          data.isSelect = false
        }
      });
      // this.offerings.forEach(function (offer) {
      //   if (offer.isIMSofferSelect) {
      //     offer.isSelect = false
      //   }
      // });
      var self = this;
      // console.log(self.offerSelected, this.offerings)
      this.offerings.forEach(function (offer) {
        if (offer.isIMSofferSelect) {
          // Check if the offer.id is already in offerSelected, only push if it's not
          if (!self.offerSelected.includes(offer.id)) {
            self.offerSelected.push(offer.id);
          }
          offer.isSelect = false
        }
        else if(!offer.isSelect) {
          // Remove the item if it's being deselected
          const index = self.offerSelected.indexOf(offer.id);
          if (index !== -1) {
            self.offerSelected.splice(index, 1); // Remove the item from the array
          }
        }
      });
      this.getTotalSelectedOffersCount();

    },
    selectSingleItem(selectedItem) {
      var self = this;
      this.allPageofferings.forEach(function (data) {
        if (data.id == selectedItem.id) {
          data.isSelect = selectedItem.isSelect
          data.isIMSofferSelect = false
          self.isSelectAll = self.allPageofferings.every(item => item.isSelect);
        }
      });
      // console.log(self.offerSelected, this.offerings)
      this.offerings.forEach(function (offer) {
        if (offer.isSelect) {
          // Check if the offer.id is already in offerSelected, only push if it's not
          if (!self.offerSelected.includes(offer.id)) {
            self.offerSelected.push(offer.id);
          }
          offer.isIMSofferSelect = false
        }
        else if(!offer.isIMSofferSelect) {
          // Remove the item if it's being deselected
          const index = self.offerSelected.indexOf(offer.id);
          if (index !== -1) {
            self.offerSelected.splice(index, 1); // Remove the item from the array
          }
        }
      });

      this.getTotalSelectedOffersCount();
    },
    sendEmailToCustomer() {
      var self = this;
      // this.offerSelected = [];
      this.offerings.forEach(function (offer) {
        if (offer.isSelect) {
          // Check if the offer.id is already in offerSelected, only push if it's not
          if (!self.offerSelected.includes(offer.id)) {
            self.offerSelected.push(offer.id);
          }
        }
        if (offer.isIMSofferSelect) {
          // Check if the offer.id is already in offerSelected, only push if it's not
          if (!self.offerSelected.includes(offer.id)) {
            self.offerSelected.push(offer.id);
          }
        }
      });
      // if (this.offerSelected.length == 0) {
      //   this.$alert("please select any offer", "", "error");
      //   return false
      // }
      console.log(this.offerSelected)
      this.sendToCustomerModalOpen = true
    },
    arrayToObject(array) {
      return array.reduce((obj, item) => {
        obj[item.filterName] = item.filterName;
        return obj;
      }, {});
    },
    getIdByFilterName(filterName) {
      const item = this.matchedFilterList.find(item => item.filterName === filterName);
      return item ? item.id : null; // Return the id if found, otherwise return null
    },
    async openExportModal() {
          // if (this.offerSelected.length) {
          //   this.exportFeedOffer();
          // } else {
            const { value } = await Swal.fire({
              title: "Offering feed export",
              html: `
                <form>
                  <div class="form-row justify-content-center mt-4">
                    ${
                    this.offerSelected.length
                      ? "" :
                        `<div class="form-group col-md-8">
                          <select id="swal-filter" class="form-control">
                          <option value="">Select filter</option>
                            ${Object.entries(this.arrayToObject(this.matchedFilterList))
                              .map(([key, value]) => `<option value="${key}">${value}</option>`)
                              .join("")}
                          </select>
                        </div>`}
                    <div class="form-group col-md-8">
                      <input id="swal-spread" type="number" class="form-control" placeholder="Enter Spread Value">
                    </div>
                  </div>  
                </form>
              `,
              showCancelButton: true,
              confirmButtonText: "Export",
              focusConfirm: false,
              preConfirm: () => {
                const spread = document.getElementById("swal-spread").value;
                let filter = null
                if(!this.offerSelected.length){
                   filter = document.getElementById("swal-filter").value;
                  if (!filter) {
                    Swal.showValidationMessage("Please select a filter");
                  }
                }
               
                // if (!spread) {
                //   Swal.showValidationMessage("Please enter a spread value");
                // }

                return { filter, spread };
              },
            });

            if (value) {
              this.exportFeedFilter(value.filter, value.spread);
            }
          //}
        },

    // async openExportModal() {
      
    //   if(this.offerSelected.length){
    //     this.exportFeedOffer();
    //   }else{
    //       const { value: filter } = await Swal.fire({
    //         title: "Please select any filter from the list for export",
    //         input: "select",
    //         inputOptions: this.arrayToObject(this.matchedFilterList),
    //         inputPlaceholder: "Select filter",
    //         showCancelButton: true,
    //       });
    //       if (filter) {
    //         this.exportFeedFilter(filter)
    //       }
    //     }
    // },
    exportFeedFilter(filterName,spread) {
      console.log(filterName,spread)
      this.isExport = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };

      var offerIds = [];
      var imsOfferIds = [];

      this.allPageofferings.forEach((offer) => {
        if (offer.isSelect) {
          offerIds.push(offer.id); 
        } else if (offer.isIMSofferSelect) {
          imsOfferIds.push(offer.imsOfferId);
        }
      });


      let data = {
        "filterId": filterName ? this.getIdByFilterName(filterName) : null,
        "clientName": "drl",
        "cognitoSub": authService.getUser().cognitoSub,
        "offeringIds" : offerIds,
        "spread" : spread ? Number(spread) : null,
        "imsOfferingIds" : imsOfferIds
      }
      this.$http
        .post(
          config.baseUrlAutoBidder +
          "/offering-feed/report", data,
          auth
        )
        .then(() => {
          this.isExport = false;
          this.$alert("Export is in progress, download file from File Logs once completed", "", "success");

        })
        .catch(e => {
          console.log(e);
          this.isExport = false;
        });
    },
    exportFeedOffer() {
      this.isExport = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      let data = {
        "filterId": null,
        "clientName": "drl",
        "cognitoSub": authService.getUser().cognitoSub,
        "offeringIds" : this.offerSelected
      }
      this.$http
        .post(
          config.baseUrlAutoBidder +
          "/offering-feed/report", data,
          auth
        )
        .then(() => {
          this.isExport = false;
          this.$alert("Export is in progress, download file from File Logs once completed", "", "success");

        })
        .catch(e => {
          console.log(e);
          this.isExport = false;
        });
    },
    getMatchedFilter(id) {

      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/offering-feed/filter-dropdown?userId=" + authService.getUser().id,
          auth
        )
        .then((res) => {
          this.matchedFilterList = res.data.content;
          if (id) {
            this.seletedFilter = this.getFilterNameById(id);
            // this.getOfferList();

          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    getFeedRecap() {
      this.countLoading = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/offering-feed/summary?cognitoSub=" + authService.getUser().cognitoSub + '&userId=' + authService.getUser().id,
          auth
        )
        .then(() => {
          this.countLoading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    nextOrPrev(nextOrPrev) {
      if (!this.loading) {

        this.getOfferList(nextOrPrev)
      }
    },
    searchOffer() {
      // console.log("d",this.offerStatus.map((status) => {return status.code}).toString())
      this.getOfferList();
    },
    clearFilter() {
      this.seletedEcn = ""
      this.seletedFilter = ""
      this.searchValue = ""
      this.getOfferList();

    },
    clearSearch() {
      this.searchValue = "";
      this.getOfferList();
    },
    sort(column) {
      this.sortColumn = column;
      this.sortOrder = this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    getStateName(id) {
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getSavedColumnOptions() {
      this.loading = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/offering-feed/column-setting?userId=" +
          authService.getUser().id,
          auth
        )
        .then(result => {
          this.loading = false;
          this.columnHeaders = result.data.columnInfos.filter(column => column.selected);
          this.getOfferList();
        })
    },
    getOfferList(mode) {
      this.loading = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      if (mode == "next") {
        this.cursor = this.nextCursor;
        if (!this.nextCursor) return
      }
      if (mode == "prev") {
        this.cursor = this.prevCursor;
        if (!this.prevCursor) return
      }
      if (!mode) {
        this.cursor = null;
        this.currentPage = 1
      }
      let url = "";
      let body = {};

      if(this.isPreviewMode){
        body = this.previewFilterPayload;
        body.cursor = this.cursor ? this.cursor : null;
        body.sortColumn = this.sortColumn ;
        body.sortOrder = this.sortOrder ;
        body.search = this.searchValue ? this.searchValue : null;
        body.ecn = this.seletedEcn ? this.seletedEcn : null;
        body.isForClient = true
        url = config.baseUrlAutoBidder+"/offering-feed/list-hits/preview"
      }else{
         body = {
          "size": this.perPage,
          "cursor": this.cursor ? this.cursor : null,
          "userId": authService.getUser().id,
          "search": this.searchValue ? this.searchValue : null,
          "ecn": this.seletedEcn ? this.seletedEcn : null,
          "sortColumn" : this.sortColumn ,
          "sortOrder" : this.sortOrder ,
          "filterIds": this.getFilterIdByName(this.seletedFilter) ? this.getFilterIdByName(this.seletedFilter) : null
        }
        url = config.baseUrlAutoBidder+"/offering-feed/list-hits"
      }
      if(!this.isListAPIProcessing && window.location.pathname == '/offeringfeed/offerings'){
        this.isListAPIProcessing = true;

      this.$http
        .post(url,body,auth)
        .then(result => {
          var self = this;
          result.data.content.forEach((offer) => {
            offer.isIMSofferSelect = false;
            offer.isSelect = false;
            if(!offer.id){
              offer.id = Math.floor(100000 + Math.random() * 900000);
              offer.isFeedOfferNull = true
            }else{
              offer.isFeedOfferNull = false
            }
          })
          this.nextCursor = result.data.pageInfo.nextCursor;
          this.prevCursor = result.data.pageInfo.prevCursor;
          this.offerings = result.data.content;
          this.loading = false;
          if (mode == "next") {
            this.currentPage = this.currentPage + 1;
          }
          if (mode == "prev") {
            this.currentPage = this.currentPage - 1;
          }
          this.isSelectAll = false;
          this.offerings.forEach((offer) => {
            const index = self.offerSelected.indexOf(offer.id);
            if (index !== -1) {
              let offerDTO = this.allPageofferings.find((data) => data.id == offer.id);
              if(offerDTO.isIMSofferSelect){
                offer.isIMSofferSelect = true
              }else{
                offer.isSelect = true

              }
              // offer.isSelect = true
            }
            this.offerings.forEach((offer) => {
              if (!this.allPageofferings.some(existingOffer => existingOffer.id === offer.id)) {
                  this.allPageofferings.push({ ...offer });
              }
            })
            this.isSelectAll = self.offerings.every(item => item.isSelect); //need to select all items in the page if all items are selected

          })
          this.isListAPIProcessing = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
      }
    },
  },
  mounted() {
    this.$root.$on("offeringfeedcount", (data) => {
      this.offeringFeedCount = JSON.parse(data.count);
    });
    this.$root.$on("offeringfeedstatus", (data) => {
      this.offeringFeedStatus = data.status;
      if(this.offeringFeedStatus.viewStatus == 'READY_FORCED'){
          this.getOfferList();
      }
    });
    this.getFeedRecap();
    this.getMatchedFilter();
    this.getSavedColumnOptions();
  },
  beforeDestroy() {
    this.$root.$off("offeringfeedcount");
    this.$root.$off("offeringfeedstatus");
    localStorage.removeItem("previewFilter");
  }
};
</script>
<style scoped>
.recap {
  padding: 6px;
  background-color: white;
  height: 31px;
  border-radius: 19px;
  float: right;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
}

.recap span {
  padding: 6px;
  position: relative;
  bottom: 4px;
}

.card a {
  margin-top: 0px;
  text-decoration: none;
  font-weight: 100;
  font-size: 13px;

}

.dropdown-menu {
  min-width: 15rem !important
}
.hint-color { 
  display: flex;
  flex-direction: row;
}
.hint-color div {
  text-align: left;
  font-size: 25px;
  font-weight: 900;
}
.hint-color .hint {
 padding: 5px;
 color: red
}
.hint-color i{
  color: #0087D4;
  font-size: 17px;
}
</style>